import React, {Component} from 'react';
import Select from 'react-select';
import axios from 'axios';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { connect } from 'react-redux';
import { Input, Alert } from 'reactstrap';
import { getAuthToken } from '../../store/utility';

class Benutzer extends Component {
    state = {
        kitas: [],
        selectedKita: null,
        admins: [],
        kitaBenutzer: [],
        selectedAdmin:{
            username: '',
            password: ''
        },
        selectedKitaBenutzer: null,
        newAdmin:{
            username: '',
            password: ''
        },
        newKitaBenutzer: {
            username: '',
            password: ''
        },
        updateAdmin: false,
        createNewAdmin: false,
        createNewKitaBenutzer: false,
        kitaBenutzerSelected: false,
        adminSelected: false,
        showCreatedAdminSuccessAlert: false,
        showCreatedKitaBenutzerSuccessAlert: false
    };

    constructor(props) {
        super(props);
        const token = getAuthToken();
        axios.get(this.props.apiUri + 'Kita', { headers: { 'Authorization': `Bearer ${token}` } })
            .then(response => {
                this.setState({ kitas: response.data });
            }).then(
            axios.get(this.props.apiUri + 'Authentication/GetAdmins', { headers: { 'Authorization': `Bearer ${token}` } })
              .then(response => {
                this.setState({ admins: response.data });
              }).then(
                  axios.get(this.props.apiUri + 'Kita/GetKitasWithKitaBenutzer', { headers: { 'Authorization': `Bearer ${token}` } })
                      .then(response => {
                          this.setState({ kitaBenutzer: response.data });
                      }).then(
                          axios.get(this.props.apiUri + 'Kita', { headers: { 'Authorization': `Bearer ${token}` } })
                              .then(response => {
                                  this.setState({ kitas: response.data });
                              }))));
    }

    //componentDidMount(){
    //    axios.get(this.props.apiUri + 'Kita', {headers: {'Authorization': `Bearer ${this.props.token}`}})
    //        .then(response => {
    //            this.setState({kitas: response.data});
    //        }).then(
    //            axios.get(this.props.apiUri + 'Test/GetAllDurchfuehrende', {headers: {'Authorization': `Bearer ${this.props.token}`}})
    //            .then(response => {
    //                this.setState({durchfuehrende: response.data});
    //            }).then(
    //                axios.get(this.props.apiUri + 'Geschlecht').then(response => {
    //                this.setState({Geschlechter: response.data});}
    //        )));
    //}


    adminChangeHandler = selectedAdmin => {
        this.setState({
            selectedAdmin: selectedAdmin,
            showCreatedAdminSuccessAlert: false
        });
    }

    kitaBenutzerChangeHandler = selectedKitaBenutzer => {
        this.setState({
            selectedKitaBenutzer: selectedKitaBenutzer,
            showCreatedKitaBenutzerSuccessAlert: false
        });
    }

    newAdminCreated = () => {
        let selectedAdmin = {
            username: '',
            password: '',
        };
        axios.get(this.props.apiUri + 'Authentication/GetAdmins', {headers: {'Authorization': `Bearer ${this.props.token}`}})
                        .then(response => {
                            this.setState({
                                admins: response.data,
                                selectedAdmin:selectedAdmin,
                                newAdmin: selectedAdmin,
                                createNewAdmin: false,
                                showCreatedAdminSuccessAlert: true
                            });
                        });
    }

    newKitaBenutzerCreated = () => {
        let selectedKitaBenutzer = {
            username: '',
            password: '',
        };
        axios.get(this.props.apiUri + 'Kita/GetKitasWithKitaBenutzer', { headers: { 'Authorization': `Bearer ${this.props.token}` } })
            .then(response => {
                this.setState({
                    kitaBenutzer: response.data,
                    selectedKitaBenutzer: selectedKitaBenutzer,
                    newKitaBenutzer: selectedKitaBenutzer,
                    createNewKitaBenutzer: false,
                    showCreatedKitaBenutzerSuccessAlert: true
                });
            });
    }

    kitaChangeHandler = selectedKita => {
        if(selectedKita != null){
            this.setState({
                selectedKita: selectedKita,
            });
        };        
    };


    toggleUpdateAdmin = value => {
        this.setState({
            updateAdmin: value
        });
    }

    toggleCreateAdmin = value => {
        this.setState({
            createNewAdmin: value
        });
    }

    toggleCreateKitaBenutzer = value => {
        this.setState({
            createNewKitaBenutzer: value
        });
    }

    AdminBenutzernameChangedHandler = value => {
        let updatedAdmin = { ...this.state.newAdmin };
        updatedAdmin.username = value;
        this.setState({
            newAdmin: updatedAdmin
        });
    }

    KitaBenutzerUsernameChangedHandler = value => {
        let updatedKitaBenutzer = { ...this.state.newKitaBenutzer };
        updatedKitaBenutzer.username = value;
        this.setState({
            newKitaBenutzer: updatedKitaBenutzer
        });
    }

    AdminPasswortChangedHandler = value => {
        let updatedAdmin = { ...this.state.newAdmin };
        updatedAdmin.password = value;
        this.setState({
            newAdmin: updatedAdmin
        });
    }

    KitaBenutzerPasswortChangedHandler = value => {
        let updatedKitaBenutzer = { ...this.state.newKitaBenutzer };
        updatedKitaBenutzer.password = value;
        this.setState({
            newKitaBenutzer: updatedKitaBenutzer
        }); 
    }

    selectedDurchfuehrenderChangedHandler = selectedDurchfuehrender => {
        this.setState({
            selectedDurchfuehrender: selectedDurchfuehrender
        });
    }

    createNewKitaBenutzer = (kitaBenutzer) => {
        axios.post(this.props.apiUri + 'Authentication/Register?pUsername=' + kitaBenutzer.username + '&pPassword=' + kitaBenutzer.password + '&pUserLevel=' + this.state.selectedKita.id, null, { headers: { 'Authorization': `Bearer ${this.props.token}` } })
            .then(response => {
                this.newKitaBenutzerCreated();
            }); 
    }

    createNewAdmin = (admin) => {
        axios.post(this.props.apiUri + 'Authentication/Register?pUsername=' + admin.username + '&pPassword=' + admin.password + '&pUserLevel=0',null , {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                this.newAdminCreated();
            }); 
    }

    updateKind = (kind) => {
        console.log(this.props.token);
        if(kind.geburtstag === undefined && kind.geburtsmonat === undefined && kind.geburtsjahr === undefined)
        {
            axios.put(this.props.apiUri + 'Kind/UpdateKind?id=' + kind.id + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id,null, {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                // console.log(response);
                // this.setState({
                //     selectedKind: kind,
                //     updateKind: false
                // });
                axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' +  this.state.selectedKita.id, {headers: {'Authorization': `Bearer ${this.props.token}`}})
                    .then(response => {
                        this.setState({
                        kinder: response.data,
                        selectedKind: kind,
                        updateKind: false
                    });
                })}); 
        }
        if(kind.geburtstag === undefined && kind.geburtsmonat === undefined && kind.geburtsjahr !== undefined)
        {
            axios.put(this.props.apiUri + 'Kind/UpdateKind?id=' + kind.id + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id +  '&pGeburtsjahr=' + kind.geburtsjahr,null, {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                // console.log(response);
                // this.setState({
                //     selectedKind: kind,
                //     updateKind: false
                // });
                axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' +  this.state.selectedKita.id, {headers: {'Authorization': `Bearer ${this.props.token}`}})
                .then(response => {
                    this.setState({
                    kinder: response.data,
                    selectedKind: kind,
                    updateKind: false
                });
            })}); 
        }
        if(kind.geburtstag === undefined && kind.geburtsmonat !== undefined && kind.geburtsjahr !== undefined){
            axios.put(this.props.apiUri + 'Kind/UpdateKind?id=' + kind.id + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id +  '&pGeburtsjahr=' + kind.geburtsjahr + '&pGeburtsmonat=' + kind.geburtsmonat,null, {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                // console.log(response);
                // this.setState({
                //     selectedKind: kind,
                //     updateKind: false
                // });
                axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' +  this.state.selectedKita.id, {headers: {'Authorization': `Bearer ${this.props.token}`}})
                .then(response => {
                    this.setState({
                    kinder: response.data,
                    selectedKind: kind,
                    updateKind: false
                });
            })}); 
        }
        if(kind.geburtstag !== undefined && kind.geburtsmonat !== undefined && kind.geburtsjahr !== undefined)
        {
            const updatedKind = { Vorname: kind.vorname, Nachname: kind.nachname, GeschlechtID: kind.geschlechtObjekt.id, Geburtsjahr: kind.geburtsjahr, Geburtsmonat: kind.geburtsmonat, Geburtstag: kind.geburtstag}
            axios.put(this.props.apiUri + 'Kind/' + kind.id,
            //  + '&pVorname=' + kind.vorname + '&pNachname=' + kind.nachname + '&pGeschlechtID=' + kind.geschlechtObjekt.id +  '&pGeburtsjahr=' + kind.geburtsjahr + '&pGeburtsmonat=' + kind.geburtsmonat + '&pGeburtstag=' + kind.geburtstag,null,
            updatedKind,
            {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                // console.log(response);
                // this.setState({
                //     selectedKind: kind,
                //     updateKind: false
                // });
                axios.get(this.props.apiUri + 'Kind/GetKinderOfKita?pKitaID=' +  this.state.selectedKita.id, {headers: {'Authorization': `Bearer ${this.props.token}`}})
                .then(response => {
                    this.setState({
                    kinder: response.data,
                    selectedKind: kind,
                    updateKind: false
                });
            })}); 
        }
    }

    CreateStringFromIndizes = (Indizes) => {
        return Indizes.join(' , ');
    }

    render(){
        const admins = [...this.state.admins];
        const kitaBenutzer = [...this.state.kitaBenutzer];

        let adminList = (
            <div>
                <Select
                    getOptionLabel={option => option.username}
                    getOptionValue={option => option.id}
                    options={admins}
                    onChange={(event) => this.adminChangeHandler(event)}
                    value={this.state.selectedAdmin}
                    isClearable='true'/>
            </div>
        );

        let kitaBenutzerList = (
                <div>
                    <Select 
                        getOptionLabel={option => option.username}
                        getOptionValue={option => option.id}
                        options={kitaBenutzer}
                        onChange={(event) => this.kitaBenutzerChangeHandler(event)}
                        value={this.state.selectedKitaBenutzer}
                        isClearable='true'/>
                </div>
            );
        

 

        let adminEdit = null;
        let kitaBenutzerEdit = null;
        if (this.state.adminSelected) {
            if (this.state.updateAdmin) {
                adminEdit = (
                    <div>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.toggleUpdateAdmin(false)}
                            type="button"> Admin nicht mehr bearbeiten
                        </button>
                        <br />
                        <br />
                        <form>
                            <div class="form-group row">
                                <label htmlFor="Benutzername" className="col-sm-1 col-form-label">Benutzername</label>
                                <div class="col-sm-5">
                                    <input type="text" className="form-control" id="Benutzername" value={this.state.newAdmin.username} onChange={(e) => this.AdminBenutzernameChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label htmlFor="Passwort" className="col-sm-1 col-form-label">Passwort</label>
                                <div class="col-sm-5">
                                    <input type="text" className="form-control" id="Passowrt" value={this.state.newAdmin.password} onChange={(e) => this.AdminPasswortChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-10">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => this.updateAdmin(this.state.newAdmin)}
                                        type="button"> Änderungen speichern
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                );
            }
            else {
                adminEdit = (
                    <div>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.toggleUpdateAdmin(true)}
                            type="button"> Admin bearbeiten
                        </button>
                        <br />
                        <br />
                        <form>
                            <div class="form-group row">
                                <label htmlFor="Benutzername" className="col-sm-1 col-form-label">Benutzername</label>
                                <div class="col-sm-5">
                                    <Input readOnly type="text" className="form-control" id="Benutzername" value={this.state.selectedAdmin.username} onChange={(e) => this.AdminBenutzernameChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label htmlFor="Passwort" className="col-sm-1 col-form-label">Passwort</label>
                                <div class="col-sm-5">
                                    <Input readOnly type="text" className="form-control" id="Passowrt" value={this.state.selectedAdmin.password} onChange={(e) => this.AdminPasswortChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-10">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => this.updateAdmin(this.state.newAdmin)}
                                        type="button"> Änderungen speichern
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>


                );
            }
        }
        else {
            if (this.state.createNewAdmin) {
                let disabled = true;
                if (this.state.newAdmin.username && this.state.newAdmin.password) {
                    disabled = false;
                }
                adminEdit = (
                    <form>
                        <div class="form-group row">
                            <label htmlFor="Benutzername" className="col-sm-1 col-form-label">Benutzername</label>
                            <div class="col-sm-5">
                                <input type="text" className="form-control" id="Benutzername" value={this.state.newAdmin.benutzername} onChange={(e) => this.AdminBenutzernameChangedHandler(e.target.value)} />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label htmlFor="Passwort" className="col-sm-1 col-form-label">Passwort</label>
                            <div class="col-sm-5">
                                <input type="text" className="form-control" id="Passowrt" value={this.state.newAdmin.passwort} onChange={(e) => this.AdminPasswortChangedHandler(e.target.value)} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-10">
                                <button
                                    disabled={disabled}
                                    className="btn btn-primary"
                                    onClick={() => this.createNewAdmin(this.state.newAdmin)}
                                    type="button"> Neuen Administrator speichern
                                </button>
                            </div>
                        </div>
                    </form>
                );
            }
            else {
                adminEdit = (
                    <div>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.toggleCreateAdmin(true)}
                            type="button"> Neuen Admin anlegen
                        </button>
                    </div>
                );
            }
        }

        if (this.state.showCreatedAdminSuccessAlert) {
            adminEdit = (
                <Alert color="success">
                    <p>Neuer Administrator erfolgreich angelegt!</p>
                </Alert>
            );
        }

        if (this.state.kitaBenutzerSelected) {
            if (this.state.kitaBenutzerUpdate) {
                kitaBenutzerEdit = (
                    <div>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.toggleUpdateKitaBenutzer(false)}
                            type="button"> Kita Benutzer nicht mehr bearbeiten
                        </button>
                        <br />
                        <br />
                        <form>
                            
                            <div class="form-group row">
                                <label htmlFor="Benutzername" className="col-sm-1 col-form-label">Benutzername</label>
                                <div class="col-sm-5">
                                    <input type="text" className="form-control" id="Benutzername" value={this.state.newKitaBenutzer.username} onChange={(e) => this.AdminBenutzernameChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label htmlFor="Passwort" className="col-sm-1 col-form-label">Passwort</label>
                                <div class="col-sm-5">
                                    <input type="text" className="form-control" id="Passowrt" value={this.state.newKitaBenutzer.password} onChange={(e) => this.AdminPasswortChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-10">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => this.updateKitaBenutzer(this.state.newKitaBenutzer)}
                                        type="button"> Änderungen speichern
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                );
            }
            else {
                kitaBenutzerEdit = (
                    <div>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.toggleUpdateKitaBenutzer(true)}
                            type="button"> Kita-Benutzer bearbeiten
                        </button>
                        <br />
                        <br />
                        <form>
                            <div class="form-group row">
                                <label htmlFor="Benutzername" className="col-sm-1 col-form-label">Benutzername</label>
                                <div class="col-sm-5">
                                    <Input readOnly type="text" className="form-control" id="Benutzername" value={this.state.selectedKitaBenutzer.username} onChange={(e) => this.AdminBenutzernameChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label htmlFor="Passwort" className="col-sm-1 col-form-label">Passwort</label>
                                <div class="col-sm-5">
                                    <Input readOnly type="text" className="form-control" id="Passowrt" value={this.state.selectedKitaBenutzer.password} onChange={(e) => this.AdminPasswortChangedHandler(e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-sm-10">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => this.updateKitaBenutzer(this.state.newKitaBenutzer)}
                                        type="button"> Änderungen speichern
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>


                );
            }
        }
        else {
            if (this.state.createNewKitaBenutzer) {
                let disabled = true;
                if (this.state.newKitaBenutzer.username && this.state.newKitaBenutzer.password && this.state.selectedKita) {
                    disabled = false;
                }
                kitaBenutzerEdit = (
                    <form>
                        <div class="form-group row">
                            <Select
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id}
                                options={this.state.kitas}
                                onChange={(event) => this.kitaChangeHandler(event)}
                                value={this.state.selectedKita}
                                isClearable='true' />
                        </div>
                        <div class="form-group row">
                            <label htmlFor="Benutzername" className="col-sm-1 col-form-label">Benutzername</label>
                            <div class="col-sm-5">
                                <input type="text" className="form-control" id="Benutzername" value={this.state.newKitaBenutzer.username} onChange={(e) => this.KitaBenutzerUsernameChangedHandler(e.target.value)} />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label htmlFor="Passwort" className="col-sm-1 col-form-label">Passwort</label>
                            <div class="col-sm-5">
                                <input type="text" className="form-control" id="Passowrt" value={this.state.newKitaBenutzer.passwort} onChange={(e) => this.KitaBenutzerPasswortChangedHandler(e.target.value)} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="col-sm-10">
                                <button
                                    disabled={disabled}
                                    className="btn btn-primary"
                                    onClick={() => this.createNewKitaBenutzer(this.state.newKitaBenutzer)}
                                    type="button"> Neuen Kita-Benutzer speichern
                                </button>
                            </div>
                        </div>
                    </form>
                );
            }
            else {
                kitaBenutzerEdit = (
                    <div>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.toggleCreateKitaBenutzer(true)}
                            type="button"> Neuen Kita-Benutzer anlegen
                        </button>
                    </div>
                );
            }
        }

        if (this.state.showCreatedKitaBenutzerSuccessAlert) {
            kitaBenutzerEdit = (
                <Alert color="success">
                    <p>Neuer Kita Benutzer erfolgreich angelegt!</p>
                </Alert>
            );
        }

        
        let kitaBenutzerTab = (
            <Tab eventKey="kitaBenutzer" title="Kita-Benutzer">
                <br />
                <h3>Liste an Kita Benutzern</h3>
                {kitaBenutzerList}
                <br />
                {kitaBenutzerEdit}
            </Tab> 
        );

        let administratorTab = (
            <Tab eventKey="admins" title="Administratoren">
                <br />
                <h3>Liste an Administratoren</h3>
                {adminList}
                <br/>
                {adminEdit}
            </Tab> 
        );
        
        return(
            <div>
                <h3>Benutzerverwaltung</h3>
                <br/>
                <Tabs defaultActiveKey="administratorTab" id="benutzerTabs">
                    {administratorTab}
                    {kitaBenutzerTab}
                </Tabs>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        apiUri: state.apiUri,
        token: state.token,
        username: state.username
    };
  };

export default connect(mapStateToProps)(Benutzer);